
import { VISIT_CONSOLE_APP } from './constants/policies'

export default { 
  ns: 'Console',
  prefix: 'console',
  shortName: 'Console',
  name: 'Console',
  icon: 'fas fa-tachometer-alt',
  description: 'Console System',
  document: '',
  policy: VISIT_CONSOLE_APP,
  isMoveToNewSite: false
}